import { useQuery } from "@tanstack/react-query";
import { LengthPieceRow } from "../models/LengthPieceRow";
import { getAllBars } from "../repositories/lengthReportRepository";

type UseAllPiecesProps = {
	startDate: Date;
	endDate: Date;
	productCode?: number | null;
	shiftId?: number | null;
	enabled?: boolean;
	onError: (error: Error) => void;
};

export const useAllPieces = ({
	startDate,
	endDate,
	productCode,
	shiftId,
	enabled = true,
	onError,
}: UseAllPiecesProps) => {
	return useQuery<LengthPieceRow[], Error>({
		queryKey: ["allPieces", startDate, endDate, productCode, shiftId],
		queryFn: () =>
			getAllBars({
				start: startDate,
				end: endDate,
				productCode,
				shiftId,
			}),
		onError,
		enabled,
	});
};
